import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DataService from "../../../../../../Service";
import Typography from "@material-ui/core/Typography";
import { useQuery } from "react-query";
const ServiceTypeFilter = (props) => {
  const fetchServiceType = () => {
    return DataService.getData({}, "fetch_service");
  };

  const { data: serviceTypeList } = useQuery(
    "service_type_list",
    fetchServiceType,
    {
      staleTime: 1800000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 1800000,
    }
  );

  const { serviceType, setServiceType } = props;

  const handleDropDownValue = (event) => {
    setServiceType(event.target.value);
  };

  return (
    <div>
      <Typography
        variant="subtitle1"
        style={{
          fontWeight: "bold",
          lineHeight: "1.75rem",
          color: "#EF7000",
        }}
      >
        Service type
      </Typography>
      <br />
      <Select
        labelId="service_type"
        defaultValue={serviceType}
        id="service_type"
        name="service_type"
        variant="outlined"
        onChange={handleDropDownValue}
        placeholder="Service Type"
        style={{ width: "235px", height: "45px" }}
        value={serviceType}
      >
        <MenuItem key="all" value="all">
          <Typography style={{ fontSize: "16px" }}>All</Typography>
        </MenuItem>
        {serviceTypeList?.services.map((serviceType, index) => {
          return (
            <MenuItem name={serviceType} key={index} value={serviceType}>
              <Typography variant="h2">{serviceType}</Typography>
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export default ServiceTypeFilter;
